import { render, staticRenderFns } from "./hormone2.vue?vue&type=template&id=1e555c2a&scoped=true&"
import script from "./hormone2.vue?vue&type=script&lang=js&"
export * from "./hormone2.vue?vue&type=script&lang=js&"
import style0 from "./hormone2.vue?vue&type=style&index=0&id=1e555c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e555c2a",
  null
  
)

export default component.exports